export const SOMETHING_WENT_WRONG = "Something went wrong";

export const ADMIN_USER_ADDED = "New Admin user has been added successfully!";
export const INVALID_USER_SELECTION =
  "Invalid user selection. The user you have selected is a Buyer and cannot be assigned as an Agent.";
export const SUBSCRIPTION_NOT_ACTIVE =
  "Your subscription is not active. Please activate to continue.";
export const TRANSACTION_CANCELED =
  "This transaction is canceled. You may not send a reply.";

/**contingencies */
export const HOME_INSPECTION = "Home Inspection";
export const RADON_INSPECTION = "Radon Inspection";
export const SEPTIC_INSPECTION = "Septic Inspection";
export const WOOD_DESTROYING_INSPECTION = "Wood Destroying Insect Inspection";
export const FINANCING = "Financing";
export const WELL_TEST = "Well Test";
export const WATER_TEST = "Water Test";
export const APPRAISAL = "Appraisal";
export const HOA_DOCS = "HOA Docs";
export const CONDO_DOCS = "Condo Docs";
export const LISTING_AGENT = "Listing Agent";
export const CLOSING_AGENT = "Closing Agent";
export const BUYER_AGENT = "Buyer Agent";
export const ARTIST = "Artist";
export const CLIENT = "Client";
export const GUARDIAN = "Guardian";
export const FIRST_APPOINTMENT = "First Appointment";
export const PAPERWORK = "Paperwork";

/** Security */
// These are user types
export const VENDOR = "VENDOR";
export const Artist = "ARTIST";
export const BUYER = "CLIENT";
export const ADMIN = "ADMIN";
export const ACCTOWNER = "ACCTOWNER";
export const BUYERAGENT = "BUYERAGENT";
export const LISTINGAGENT = "LISTINGAGENT";
export const CLOSINGAGENT = "CLOSINGAGENT";
// These are permission types
export const DOCUMENT_VIEWER = "DOCUMENT_VIEWER";
export const CLIENT_EDITOR = "CLIENT_EDITOR";
export const CLIENT_VIEWER = "CLIENT_VIEWER";
export const CONTACT_EDITOR = "CONTACT_EDITOR";
export const CONTACT_VIEWER = "CONTACT_VIEWER";
export const CAMPAIGN_MANAGER = "CAMPAIGN_MANAGER";
export const CALENDAR_MANAGER = "CALENDAR_MANAGER";
export const DASHBOARD_VIEWER = "DASHBOARD_VIEWER";
export const TRANSACTION_VIEWER = "TRANSACTION_VIEWER";
export const TRANSACTION_EDITOR = "TRANSACTION_EDITOR";
export const TRANSACTION_CREATOR = "TRANSACTION_CREATOR";
export const PROFILE_MANAGER = "PROFILE_MANAGER";
export const BUYERAGENT_VIEWABLE = "BUYERAGENT_VIEWABLE";
export const ADMIN_VIEWABLE = "ADMIN_VIEWABLE";
export const ARTIST_VIEWABLE = "ARTIST_VIEWABLE";

// Standard Forms
export const STANDARD_FORMS = ["INTAKE", "CONSENT", "CLIENT_SUMMARY"];

/*** Validation messages */
export const ENTER_FIRST_NAME = "Please enter a first name";
export const ENTER_LAST_NAME = "Please enter a last name";
export const ENTER_USER_NAME = "Please enter a username";
export const USER_NAME_LENGTH = "user name required minimum 4 digits";
export const USER_NAME_EXISTS = "Username already exists.";
export const ENTER_VALID_USER_NAME =
  "Username should start with lowercase letters & can have numbers, special characters like @._";
export const ENTER_VALID_FIRST_NAME = "Please enter valid first name";
export const ENTER_VALID_LAST_NAME = "Please enter valid last name";
export const ENTER_VALID_PASSWORD =
  "Please enter valid password (consisting only of non-whitespaces)";

export const ENTER_EMAIL = "Please enter an email address";
export const ENTER_CONFIRM_EMAIL = "Please confirm your email address";
export const CONFIRM_EMAIL_SAME_AS_EMAIL = "Email addresses do not match";
export const ENTER_VALID_EMAIL = "Please enter valid email address";
export const ENTER_VALID_RICIPIENT = "Please enter an email recipient";
export const ENTER_SUBJECT = "Please enter a subject";
export const ENTER_EMAIL_MESSAGE = "Please enter an email message";
export const EMAIL_EXISTS = "Email already exists.";
export const ENTER_EMAIL_OR_MOBILE =
  "Please enter an email address or mobile number";
export const SELECT_DATE = "Please select a date";
export const SELECT_SLOT = "Please select a slot";

export const ENTER_VALID_MOBILE = "Please enter a valid mobile number";
export const ENTER_MOBILE_NUMBER = "Please enter a mobile number";
export const MOBILE_10_DIGIT = "Mobile number must be at least 10 digits";
export const ENTER_PHONE = "Please enter a phone number";
export const PHONE_10_DIGIT = "Phone number must be at least 10 digits";
export const MOBILE_NUMBER_EXISTS = "Mobile number already exists.";

export const ENTER_COMPANY_NAME = "Please enter a company name";
export const ENTER_COMPANY_ADDRESS = "Please enter a company address";
export const ENTER_CITY = "Please enter a city";
export const SELECT_STATE = "Please select a state";
export const ENTER_PERCENTAGE = "Please enter a commission percentage";
export const ENTER_ZIP = "Please enter a zip code";
export const ENTER_VALID_ZIP = "Please enter a valid zip code";

export const VALID_COMPANY_WEBSITE = "Must be a valid URL";
export const ENTER_BROKER_LICENSE = "Please enter a broker license number";
export const VALID_URL = "Must be a valid URL";

export const PASSWORD_RESET_LINK_SENT = "Password reset link sent";
export const SELECT_YOUR_PLAN = "Please select your plan";
export const REQUIRED_VENDOR_TYPE = "Please select a role for this contact";

export const FOLDER_ARCHIVED = "Folder archived successfully";
export const DOCUMENT_MOVED = "Document moved successfully";
export const DOCUMENT_RESTORED = "Document restored";
export const DEACTIVATE = "Your account is deactivated.";
export const YOUR_ACCOUNT_LOCKED =
  "Too many failed login attempts. Your account has been locked. Please contact administrator for assistance.";
export const ACCESS_PWD_NOT_SET = "You have not created a password yet.";

export const ENTER_PASSWORD = "Please enter a password";
export const PASSWORD_LENGTH = "Password should be a minimum of 6 characters";
export const CONFIRM_PASSWORD = "Please confirm your password";
export const CONFIRM_PASSWORD_MATCH = "Passwords must match";

export const ENTER_TASK_TITLE = "Please enter a task title";
export const SELECT_TASK_TYPE = "Please select a task type";
export const SELECT_COMMUNICATION_TYPE = "Please select a communication type";
export const ENTER_DESCRIPTION = "Please enter a task description";
export const SELECT_CONTINGENCY = "Please select contingency";

export const ENTER_TEXT_RECIPIENT = "Please enter a text recipient";
export const ENTER_TEXT_MESSAGE = "Please enter a text message";
export const ENTER_ASSIGN_TO = "Please select an assignee for this task";
export const ENTER_DETAILS = "Please enter details";
export const ENTER_CAMPAIGN_NAME = "Please enter a campaign name";
export const ENTER_CAMPAIGN_DURATION = "Please enter a campaign duration";
export const ENTER_ADDRESS_LINE = "Please enter an address";
export const SELECT_ASIGNEE = "Please select an assignee for this task";

export const ENTER_CLIENT_FIRST_NAME = "Please enter the client's first name";
export const ENTER_CLIENT_LAST_NAME = "Please enter the client's last name";

export const ENTER_VALID_FOLDER_NAME = "Special character ',' is not allowed";
export const ACCESS_DENIED = "You are not authorized to access this page";

export const ENTER_COLOR = "Please select a color";
export const ENTER_BILLING_ITEM_CODE = "Please enter billing item code";
export const ENTER_BILLING_ITEM_DESC = "Please enter billing item description";
export const MAX_BILLING_ITEM = "Maximum 20 digits are allowed";
export const CHARGES_PER_NOT_ZERO = "Charges per not allowed to be zero";
export const ENTER_APPLICATION_NAME = "Please enter an application name";
export const ENTER_PlAN_NAME = "Please enter a plan name";

export const END_DATE_INVALID = "End date must be greater than start date";
export const SELECT_BILLING_PLAN = "Please select a plan";
export const BANNER_END_DATE_INVALID =
  "End date must be same or greater than start date";

export const CONTACT_REQUIRED = "Please select contact";
export const CONTACT_ADDED = "New contact has been added successfully!";
export const CONTACT_UPDATED = "Contact has been updated successfully!";
export const CONTACT_ALREADY_EXISTS = "Contact already exists.";
export const CONTACT_WITH_ROLE_ALREADY_EXISTS =
  "Artist with the chosen permission already exists.";
export const EMAIL_CCEMAIL_MATCHED =
  "Email and CC email addresses should not be the same.";
export const USER_EXISTS = "User already exists.";

export const ARTIST_PERMISSION_ADDED =
  "New artist permission has been added successfully!";

export const ENTER_SYSBANNER_TITLE = "Please enter system banner title";
export const ENTER_SYSBANNER_VERSION = "Please enter system  version";
export const ENTER_SYSBANNER_MESSAGE = "Please enter system banner message";
export const ENTER_SYSVERSION_MESSAGE = "Please enter system version message";
export const ENTER_SYSBANNER_REFERENCELINK =
  "Please enter system banner referenceLink";
export const ENTER_SYSVERSION_TITLE = "Please enter system version title";
export const ENTER_PRORER_LINK = "Must be a valid URL";

export const USER_CAMPAIGN_DEFAULT_SUCCESS =
  "Default campaign updated successfully!";
export const USER_PATHWAY_DEFAULT_SUCCESS =
  "Default pathway updated successfully!";

export const ENTER_CONTINGENCY_NAME = "Please enter a name";
export const SELECT_CONTINGENCY_ROLE = "Please select a role";
export const CONTINGENCY_ADDED = "New contingency has been added successfully!";
export const CONTINGENCY_UPDATED = "Contingency has been updated successfully!";

export const ENTER_NAME = "Please enter name";
export const ENTER_VALID_NAME = "Please enter valid name";

export const TRANSACTION_PAYMENT_UPDATE =
  "Card process billing details updated successfully!";

export const ENTER_PAYMENT_TYPE = "Please enter payment type";
export const ENTER_PAYMENT_MODE = "Please enter payment mode";
export const ENTER_AMOUNT = "Please enter amount";
export const ENTER_VALID_AMOUNT = "Please enter valid amount";
export const AMOUNT_INVALID = "Amount should not be greater than total cost";
export const DEPOSIT_AMOUNT_INVALID =
  "Amount should not be greater than balance owed for deposit";
export const PARTIAL_AMOUNT_INVALID =
  "Amount should not be greater than balance owed for partial payment";
export const FULL_AMOUNT_INVALID =
  "Amount should be same as balance owed for full payment";

export const ENTER_MID = "Please enter a MID";
export const ENTER_DEVELOPER_KEY = "Please enter a developer key";
export const ENTER_API_PASSWORD = "Please enter an API password";
export const ENTER_INVOICE_PREFIX = "Please enter an invoice prefix";
export const INVOICE_PREFIX_EXISTS = "An invoice prefix already exists";
export const INVOICE_PREFIX_INVALID =
  "Please enter uppercase alphanumeric between min 2 and max 6 chars";
export const ENTER_APPSOURCE = "Please enter an appsource";

export const ENTER_PUBLIC_URL_POSTFIX = "Please enter public profile url";
export const PUBLIC_URL_POSTFIX_EXISTS = "Public profile url already exists";
export const PUBLIC_URL_POSTFIX_INVALID =
  "Please enter lowercase alphanumeric seperated by hyphen between min 2 and max 30 chars";

export const ENTER_CATEGORY_NAME = "Please enter category name";
export const ENTER_SUBCATEGORY_NAME = "Please enter subcategory name";
export const SELECT_CATEGORY = "Please select category";
export const SELECT_SUBCATEGORY = "Please select subcategory";
export const ENTER_PROMPT_DESCRIPTION = "Please enter prompt description";
export const ENTER_PROMPT_TEMPLATE = "Please enter prompt template";
export const MAX_DOCUMENT_ID = "Maximum 20 characters are allowed";

/*permissions */
// export const MANAGE_TRANSACTIONS = "MANAGE_TRANSACTIONS";
// export const VIEW_CALENDAR = "VIEW_CALENDAR";
// export const VIEW_PLAN_DETAILS = "VIEW_PLAN_DETAILS";
// export const VIEW_PAYMENT_METHOD = "VIEW_PAYMENT_METHOD";
// export const VIEW_BILLING_DETAILS = "VIEW_BILLING_DETAILS";
// export const VIEW_MASTER_CAMPAIGN = "VIEW_MASTER_CAMPAIGN";
// export const MANAGE_MASTER_CAMPAIGN = "MANAGE_MASTER_CAMPAIGN";
// export const MANAGE_PERMISSIONS_ROLE = "MANAGE_PERMISSIONS_ROLE";
// export const MANAGE_CONTACT = "MANAGE_CONTACT";
// export const VIEW_CONTACT = "VIEW_CONTACT";
// export const CHANGE_COMPANY = "CHANGE_COMPANY";
// export const MANAGE_PAYMENT_METHOD = "MANAGE_PAYMENT_METHOD";
// export const MANAGE_BILLING_DETAILS = "MANAGE_BILLING_DETAILS";
// export const VIEW_APPOINTMENTS = "VIEW_APPOINTMENTS";
// export const MANAGE_APPOINTMENTS = "MANAGE_APPOINTMENTS";
// export const APPONTMENTS_MANAGER = "APPONTMENTS_MANAGER";
// export const VIEW_PERMISSION_CONTACT = "VIEW_PERMISSION_CONTACT";
// export const MANAGE_PERMISSION_CONTACT = "MANAGE_PERMISSION_CONTACT";
// export const VIEW_PATHWAY = "VIEW_PATHWAY";
// export const MANAGE_PATHWAY = "MANAGE_PATHWAY";

/*permissions */

export const manage_transactions = "manage_transactions";
export const view_calendar = "view_calendar";
export const view_plan_details = "view_plan_details";
export const view_payment_method = "view_payment_method";
export const view_billing_details = "view_billing_details";
export const view_master_campaign = "view_master_campaign";
export const manage_master_campaign = "manage_master_campaign";
export const MANAGE_PERMISSIONS_ROLE = "MANAGE_PERMISSIONS_ROLE";
export const manage_contact = "manage_contact";
export const view_contact = "view_contact";
export const change_company = "change_company";
export const manage_payment_method = "manage_payment_method";
export const manage_billing_details = "manage_billing_details";
export const view_appointments = "view_appointments";
export const manage_appointments = "manage_appointments";
export const APPONTMENTS_MANAGER = "APPONTMENTS_MANAGER";
export const view_permission_contact = "view_permission_contact";
export const manage_permission_contact = "manage_permission_contact";
export const view_pathway = "view_pathway";
export const manage_pathway = "manage_pathway";
export const manage_client = "manage_client";
export const view_client = "view_client";
export const QUICK_APPONTMENT_MANAGER = "QUICK_APPONTMENT_MANAGER";
export const manage_quick_appointment = "manage_quick_appointment";
export const aiimagetool = "aiimagetool";
export const MANAGE_IMAGE_AI = "manage_image_ai";
export const THIS_FEILD_IS_REQUIRED = "This feild is required";
